

//  match height
$(document).ready(function(){

    var highestBox = 0;
        $('.product_page .about_home_item p').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.product_page .about_home_item p').height(highestBox);
    let subHeadingTxt = document.getElementsByClassName('subheading_desktop_font');
    let headingClass = document.getElementsByClassName('heading_desktop_font');
    if (subHeadingTxt.length == 0) {
        for (let i = 0; i < headingClass.length; i++) {
            headingClass[i].parentElement.classList.add('gap_35');
        }
    }


}); 

// quantity
$('.add').click(function () {
    $(this).prev().val(+$(this).prev().val() + 1);
});
$('.sub').click(function () {
    if ($(this).next().val() > 1) {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    }
});

jQuery(window).on('load resize', function(){
  
  var desNewHeight = 0; //for the description section
  var headerNewHeight = 0; //for the description section
  var imgNewHeight = 0; //for the description section

   jQuery('.blog_detail .blog_title').each(function(){       
      if(headerNewHeight < jQuery(this).outerHeight()){
          headerNewHeight = jQuery(this).outerHeight();
       }  
  });
  jQuery('.blog_detail .title-single-related-post').each(function(){       
      if(desNewHeight < jQuery(this).outerHeight()){
          desNewHeight = jQuery(this).outerHeight();
       }  
  });
  jQuery('.main_content_box .card_img').each(function(){       
      if(imgNewHeight < jQuery(this).outerHeight()){
          imgNewHeight = jQuery(this).outerHeight();
       }  
  });
  jQuery('.blog_detail .blog_title').css('min-height', headerNewHeight);
  jQuery('.blog_detail .title-single-related-post').css('min-height', headerNewHeight);
  jQuery('.main_content_box .content_card').css('min-height', imgNewHeight);
});   


document.addEventListener('variant_change', function(e){
  let currentVariant = e.detail.currentVariant;
  let option1 = currentVariant.option1;
  let sizeText = '';
  // console.log('currentVariant', currentVariant);

  if(option1 == 'S') {
    sizeText = document.querySelector('variant-radios').getAttribute('data-size-s');
  } else if(option1 == 'M') {
    sizeText = document.querySelector('variant-radios').getAttribute('data-size-m');
  } else if(option1 == 'L') {
    sizeText = document.querySelector('variant-radios').getAttribute('data-size-l');
  } else if(option1 == 'XL') {
    sizeText = document.querySelector('variant-radios').getAttribute('data-size-xl');
  }

  // Check if sizeText is not empty before appending the quotation mark
  document.querySelector('.product-form__input .option-value').innerHTML = sizeText ? sizeText + '"' : sizeText;
  document.querySelector('.variant-sku').textContent = currentVariant.sku;
});